import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DeliverySection, FinalSection, HeaderSection, ItemsSection, OtherInformationSection, PaymentSection, SpecificRequirementsSection } from 'src/app/shared/models/data/documentTemplate';
import { EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { TranslateService } from '@ngx-translate/core';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import htmlToPdfMake from 'html-to-pdfmake';
import { withAssetVersion } from 'src/app/shared/utils/asset-version';


pdfMake.vfs = pdfFonts.pdfMake.vfs;

let roundDigitsCache: RoundDigit[] | null = null;
let quotationRoundDigitsCache: RoundDigit[] | null = null;

export function generatePdf(translation: any, titleFontSize: number = 16, yourRef: string, ourRef: string): any {

    const headerLabel = yourRef ? `${translation['quotation']['your_ref']} ${yourRef} / ${translation['quotation']['our_offer_no']} ${ourRef}` : `${translation['quotation']['our_offer_no']} ${ourRef}`

    const docDefinition = {
        header: {
            columns: [
                {
                    text: headerLabel,
                    width: '*',
                    margin: [30, 30, 10, 0]
                },
                {
                    image: 'data:image/png;base64,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',
                    width: 90,
                    alignment: 'right'
                }
            ],
            margin: [0, 10, 30, 0]
        },
        content: [
            { text: translation['quotation']['Quotation'], fontSize: titleFontSize, margin: [0, 0, 0, 20] }
        ],
        pageMargins: [30, 90, 30, 90]

    };
    return docDefinition;
}


export function addWatermark(docDefinition: any, text: string = 'DRAFT') {
    docDefinition.watermark = { text: text, color: 'blue', opacity: 0.2, bold: true, italics: false, fontSize: 92 };
}

export function addFooterToAllPages(docDefinition: any, salesOfficeCode: string) {
    const officeFooter = getOfficeFooter(salesOfficeCode);

    docDefinition.footer = function (currentPage: number, pageCount: number) {
        return {
            stack: [
                {
                    text: 'We refer to our General Terms and Conditions of Sale and Payment, dated 1.11.2024, that apply exclusively',
                    fontSize: 10,
                },
                {
                    text: officeFooter,
                    fontSize: 8,
                },
                {
                    text: `Page ${currentPage} of ${pageCount}`,
                    fontSize: 8,
                    margin: [0, 8, 0, 0],
                    alignment: 'right',
                },
            ],
            margin: [30, 10, 30, 20]
        };
    };
}

export function getNumberOfPages(pdfDocGenerator: any): Promise<number> {
    return new Promise((resolve, reject) => {
        try {
            pdfDocGenerator._getPages({}, function (res: any[]) {
                resolve(res.length);
            })
        } catch (error) {
            reject(error)
        }
    });
}


export function addChapterHeading(chapterNumber: number, chapterTitle: string): any {
    return { text: `${chapterNumber} - ${chapterTitle}`, style: 'header', margin: [0, 10, 0, 10] };
}

// function buildTranslationKey(label: string) {
//     return 'quotation.' + label;
// }

// function getTranslation(translate: TranslateService, label: string) {
//     return translate.get() .instant(buildTranslationKey(label));
// }

export function generateHeaderSection(headerSection: HeaderSection, translation: any, getFormattedDate: (date: number) => string): any {

    const headerTableBody = [
        [{ text: translation['quotation']['to'] + ':', bold: true }, headerSection.topSection.fields['to'].value, { text: translation['quotation']['from'] + ':', bold: true }, headerSection.topSection.fields['from'].value],
        [{ text: translation['quotation']['company'] + ':', bold: true }, headerSection.topSection.fields['company'].value, { text: translation['quotation']['phone'] + ':', bold: true }, headerSection.topSection.fields['phone'].value],
        [{ text: translation['quotation']['date'] + ':', bold: true }, getFormattedDate(headerSection.topSection.fields['date'].value), { text: translation['quotation']['email'] + ':', bold: true }, headerSection.topSection.fields['email'].value],
        [{ text: translation['quotation']['pages'] + ':', bold: true }, headerSection.topSection.fields['pages'].value, { text: translation['quotation']['appendices'] + ':', bold: true }, headerSection.topSection.fields['appendices'].value]
    ];

    const middleSectionBody = [
        [{ text: translation['quotation']['your_ref'], bold: true }, headerSection.middleSection.fields['your_ref'].value],
        [{ text: translation['quotation']['our_offer_no'], bold: true }, headerSection.middleSection.fields['our_offer_no'].value],
    ];

    if (!headerSection.middleSection.fields['destination'].hidden) {
        middleSectionBody.push([{ text: translation['quotation']['destination'], bold: true }, headerSection.middleSection.fields['destination'].value]);
    }

    return [
        {
            table: {
                layout: 'lightHorizontalLines',
                widths: ['15%', '25%', '15%', '45%'],
                body: headerTableBody
            }
        },
        {
            table: {
                layout: 'lightHorizontalLines',
                widths: ['25%', '75%'],
                body: middleSectionBody
            },
            margin: [0, 10, 0, 10]
        },
        htmlToPdfMake(normalizeHtmlForPdf(headerSection.bottomSection.value!))
    ];
}

export async function generateOtherInformationSection(otherInfo: OtherInformationSection): Promise<any> {
    const content: any[] = [];

    otherInfo.sections.filter(s => !!s.value).forEach(subSection => {
        content.push({
            stack: [
                { text: `${subSection.title}:`, bold: true, margin: [0, 5, 0, 5] },
                htmlToPdfMake(normalizeHtmlForPdf(subSection.value))
            ],
            unbreakable: true // Ensures the block does not break across pages
        });
    });

    content.push(htmlToPdfMake(normalizeHtmlForPdf(otherInfo.bottomSection.value!)));

    return content;
}

export async function generateDeliverySection(delivery: DeliverySection, offerValidity: string, deliveryDate: string): Promise<any> {

    let content = `${delivery.section.value}`;
    content = content.replace(/\{\{ option_date \}\}/g, offerValidity);
    content = content.replace(/\{\{ delivery_week \}\}/g, deliveryDate);


    return [
        // addChapterHeading(4, 'Delivery'),
        htmlToPdfMake(normalizeHtmlForPdf(content))
    ];
}

export async function generatePaymentSection(payment: PaymentSection, translations: any): Promise<any> {

    let parsedHtml = replaceSelectsWithSelectedValues(payment.section.value!, payment.selectedValues);
    return [
        { text: translations['quotation.termsOfPayment'], bold: true, style: 'header' },
        htmlToPdfMake(normalizeHtmlForPdf(parsedHtml))
    ];
}

export function generateSpecificRequirementsSection(section: SpecificRequirementsSection, translation: any): any {
    if (!section?.section?.value || !section.section.value.trim()) {
        return [];
    }

    return [
        { text: translation['quotation']['specificRequirements'], bold: true, margin: [0, 0, 0, 2] },
        htmlToPdfMake(normalizeHtmlForPdf(section.section.value))
    ];
}

function getNestedValue(obj: any, key: any) {
    return key.split('.').reduce((o: any, k: any) => (o || {})[k], obj);
}

// The customer-facing "Item No" column is customerItemNo, so both the printed grid and the
// on-screen one must be ordered by it; items without a customerItemNo go last, ordered by
// the internal itemNo (which also breaks ties between duplicated customerItemNo).
export function compareItemsByCustomerItemNo(a: EnquiryHeaderItem, b: EnquiryHeaderItem): number {
    const aNo = (a.customerItemNo ?? '').toString().trim();
    const bNo = (b.customerItemNo ?? '').toString().trim();

    if (!aNo || !bNo) {
        if (aNo) return -1;
        if (bNo) return 1;
    } else {
        const byCustomerNo = aNo.localeCompare(bNo, undefined, { numeric: true });
        if (byCustomerNo !== 0) {
            return byCustomerNo;
        }
    }

    return (a.itemNo ?? '').localeCompare(b.itemNo ?? '', undefined, { numeric: true });
}

export async function generateGenericItemsSection(
    section: ItemsSection,
    translation: any,
    getFormattedDate: (date: number) => string,
    culture?: string,
    language?: string
): Promise<any> {

    // const content: any[] = [{ text: section.sectionName, bold: true, fontSize: 12, margin: [0, 10, 0, 10] }];
    const content: any[] = [];

    const items = [...section.items].sort(compareItemsByCustomerItemNo);


    if (section.technicalDescription) {
        let parsedHtml = replaceSelectsWithSelectedValues(section.technicalDescription.value!, section.technicalDescription.selectedValues);

        content.push(htmlToPdfMake(normalizeHtmlForPdf(parsedHtml)));
    }

    const visibleFields = section.fields.filter(field => !field.hidden);
    const columnCount = visibleFields.length;

    // Calculate font size based on the number of columns
    // If there are 8 columns, the font size remains 12 (maximum font size).
    // If there are more than 8 columns, the font size decreases by 1 for each additional column. (min 7)
    const baseFontSize = Math.max(7, Math.min(12, 12 - (columnCount - 8)));
    const dynamicWidths = visibleFields.map(() => `${100 / columnCount}%`);

    const makeHeaderCell = (label: string) => {
        const words = label.trim().split(/\s+/);
        const display = words.length > 1 ? `${words.shift()}\n${words.join(' ')}` : label;
        return { text: display, fontSize: baseFontSize, alignment: 'center', lineHeight: 1.1 };
    };

    // if there is at least one item, get the uoms to put in the headers
    const tableHeaders = visibleFields.map(field => {
        const raw = field.renderCustomLabel
            ? field.renderCustomLabel(items[0], translation)
            : translation['quotation'][field.label.charAt(0).toUpperCase() + field.label.slice(1)];
        return makeHeaderCell(raw);
    });


    const sums: { [key: string]: number } = {
        totalWeight: 0,
        totalLength: 0,
        totalPrice: 0
    };
    const uoms: { [key: string]: string | null } = {
        totalWeightUom: null,
        totalLengthUom: null,
        totalPriceUom: null
    };
    const shouldDisplaySums = section.showTotalWeight || section.showTotalLength || section.showTotalPrice;
    let totalWeightDigits: number | undefined;
    let totalLengthDigits: number | undefined;
    let totalPriceDigits: number | undefined;

    items.forEach(item => {
        ['totalWeight', 'totalLength', 'totalPrice'].forEach(key => {
            const value = parseFloat(getNestedValue(item, key)) || 0;
            const uomKey = key + 'Uom';
            const uom = getNestedValue(item, uomKey);

            if (!uoms[uomKey]) {
                uoms[uomKey] = uom;
            } else if (uoms[uomKey] !== uom) {
                uoms[uomKey] = 'mismatch';
            }

            sums[key] += value;
        });
    });

    if (shouldDisplaySums && items.length) {
        const unitSystem = items.find(item => item?.unitSystem)?.unitSystem;
        const roundDigits = await getQuotationRoundDigits();
        totalWeightDigits = getDigitsForField(roundDigits, 'totalWeightStd', unitSystem);
        totalLengthDigits = getDigitsForField(roundDigits, 'totalLength', unitSystem);
        totalPriceDigits = getDigitsForField(roundDigits, 'totalPrice', unitSystem);
    }

    const tableData = items.map(item => {
        const itemForRender = {
            ...item,
            quantityUom: translateQuantityUom(item.quantityUom, language),
            __quotationLanguage: language
        };
        return visibleFields.map(field => {
            const value = field.render ? field.render(itemForRender, getFormattedDate, culture) : getNestedValue(itemForRender, field.label) || '';
            return { text: value, fontSize: baseFontSize, alignment: 'center' };
        });
    });

    content.push({
        table: {
            headerRows: 1,
            widths: visibleFields.map(() => 'auto'),
            // widths: dynamicWidths,
            body: [tableHeaders, ...tableData],
            dontBreakRows: true
        },
        margin: [0, 10, 0, 10],
        dontBreakRows: true,
        layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.4,
            hLineColor: () => '#aaa',
            vLineColor: () => '#aaa',
        },
    });


    // Add the sum rows only if UOMs match
    if (section.showTotalWeight && uoms['totalWeightUom'] !== 'mismatch') {
        content.push({
            text: `${translation['quotation']['TotalWeight']}: ${formatSum(sums['totalWeight'], culture, totalWeightDigits)} ${uoms['totalWeightUom'] || ''}`,
            alignment: 'right',
            margin: [0, 10, 0, 0],
        });
    }
    if (section.showTotalLength && uoms['totalLengthUom'] !== 'mismatch') {
        content.push({
            text: `${translation['quotation']['TotalLength']}: ${formatSum(sums['totalLength'], culture, totalLengthDigits)} ${uoms['totalLengthUom'] || ''}`,
            alignment: 'right',
            margin: [0, 5, 0, 0],
        });
    }
    if (section.showTotalPrice && uoms['totalPriceUom'] !== 'mismatch') {
        content.push({
            text: `${translation['quotation']['TotalPrice']}: ${formatSum(sums['totalPrice'], culture, totalPriceDigits)} ${uoms['totalPriceUom'] || ''}`,
            alignment: 'right',
            margin: [0, 5, 0, 0],
        });
    }

    if (section.freeText) {
        content.push(htmlToPdfMake(normalizeHtmlForPdf(section.freeText)));
    }

    return content;
}

function formatSum(value: number, culture: string = 'en-UK', digits?: number) {
    const fractionDigits = typeof digits === 'number' ? digits : 2;
    const loc = new Intl.Locale(culture ?? 'en-UK', { numberingSystem: 'latn' });
    const nf = new Intl.NumberFormat(loc, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });
    return nf.format(value).replace(/\u202F/g, '\u00A0'); // narrow NBSP -> NBSP
}

function translateQuantityUom(uom: string | null | undefined, language?: string) {
    if (!uom) {
        return uom;
    }
    if (language?.toLowerCase() === 'de' && uom.toLowerCase() === 'pcs') {
        return 'Stk';
    }
    return uom;
}

async function getQuotationRoundDigits(): Promise<RoundDigit[]> {
    if (!quotationRoundDigitsCache) {
        if (!roundDigitsCache) {
            try {
                const response = await fetch(withAssetVersion('assets/mock/roundDigits.json'));
                roundDigitsCache = await response.json();
            } catch (error) {
                console.error('Error loading roundDigits.json for PDF generation', error);
                roundDigitsCache = [];
            }
        }
        const cache = roundDigitsCache ?? [];
        quotationRoundDigitsCache = cache.filter(digit => digit.section?.toLowerCase() === 'quotation');
    }
    return quotationRoundDigitsCache;
}

function getDigitsForField(roundDigits: RoundDigit[], fieldName: string, unitSystem?: string): number | undefined {
    const match = roundDigits.find(digit => digit.fieldName?.toLowerCase() === fieldName.toLowerCase());
    if (!match) {
        return undefined;
    }

    const isImperial = unitSystem?.toLowerCase() === 'imperial';
    const primaryDigits = isImperial ? match.imperialDigits : match.metricDigits;
    if (typeof primaryDigits === 'number') {
        return primaryDigits;
    }

    const fallbackDigits = isImperial ? match.metricDigits : match.imperialDigits;
    return typeof fallbackDigits === 'number' ? fallbackDigits : undefined;
}



function replaceSelectsWithSelectedValues(htmlContent: string, selectedValues?: { [selectId: string]: string }): string {
    if (!selectedValues) return htmlContent;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');

    // Replace each <select> element with its selected value
    const selects = doc.querySelectorAll('select');
    selects.forEach(select => {
        const selectId = select.id;
        const selectedValue = selectedValues[selectId];

        // If a selected value is found, use it; otherwise, default to the first option
        const replacementValue = selectedValue || select.options[0]?.textContent || '';

        const textNode = document.createTextNode(replacementValue);
        select.replaceWith(textNode);
    });

    return doc.body.innerHTML;
}

export function generateFinalSection(finalSection: FinalSection, salesPerson: string, salesOffice: string): any {

    const signature = `${salesPerson} / DMV / ${salesOffice}`;
    const content = htmlToPdfMake(normalizeHtmlForPdf(finalSection.section.value!)).filter((block: any) => block.text != ' ');
    return [
        content,
        { text: signature, margin: [0, 10, 0, 10] },
    ];
}

/**
 * Prepares editor HTML for html-to-pdfmake: font sizes are scaled for the PDF and every
 * CSS colour is resolved through the browser so the PDF shows exactly what the editor shows.
 */
export function normalizeHtmlForPdf(htmlContent: string): string {
    return normalizeColorsForPdf(normalizeFontSizesForPdf(htmlContent));
}

const PX_TO_PT = 0.85;
const BASE_PDF_FONT_SIZE = 18;

function normalizeFontSizesForPdf(htmlContent: string): string {
    if (!htmlContent) {
        return htmlContent;
    }

    const withNormalizedBreaks = htmlContent
        .replace(/\r\n|\r|\n/g, '<br/>')
        .replace(/<br\s*\/?>/gi, '<br/>');

    // Preserve empty paragraphs generated by the editor (e.g. consecutive Enters).
    const withPreservedEmptyParagraphs = withNormalizedBreaks
        .replace(/<p(\b[^>]*)>\s*(<br\s*\/?>)?\s*<\/p>/gi, '<p$1>&nbsp;</p>');

    const withEm = withPreservedEmptyParagraphs.replace(/font-size\s*:\s*([0-9]*\.?[0-9]+)em/gi, (_, size) => {
        const em = Number.parseFloat(size);
        if (Number.isNaN(em)) {
            return `font-size:${size}em`;
        }

        const scaled = Math.round(em * BASE_PDF_FONT_SIZE * 100) / 100;
        return `font-size:${scaled}px`;
    });

    return withEm.replace(/font-size\s*:\s*([0-9]*\.?[0-9]+)px/gi, (_, size) => {
        const px = Number.parseFloat(size);
        if (Number.isNaN(px)) {
            return `font-size:${size}px`;
        }

        const scaled = Math.round(px * PX_TO_PT * 100) / 100;
        return `font-size:${scaled}px`;
    });
}


const COLOR_STYLE_PROPERTIES = new Set(['color', 'background-color']);
const STYLE_ATTRIBUTE_REGEX = /(\sstyle\s*=\s*)(["'])(.*?)\2/gi;
// Keywords that resolve relative to the surrounding text: the editor shows the default text colour,
// so the PDF must fall back to its default colour as well.
const RELATIVE_COLOR_KEYWORDS = new Set(['inherit', 'initial', 'unset', 'revert', 'revert-layer', 'currentcolor']);
const LEGACY_RGB_REGEX = /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([\d.]+)\s*)?\)$/i;
const resolvedCssColorCache = new Map<string, string | null>();

/**
 * Pasted content (Word/Outlook, web pages, ...) carries colours such as "windowtext", "oklch(...)"
 * or "currentcolor" that browsers render fine but pdfmake silently ignores. When that happens the
 * text keeps the fill colour of the last drawn element - typically the white background rectangle
 * of the same text - and disappears from the PDF. Every colour declaration is therefore resolved
 * by the browser into a plain #rrggbb value (blended over the white page); declarations the browser
 * cannot resolve are removed so the PDF uses its default colour, just like the editor does.
 */
export function normalizeColorsForPdf(htmlContent: string): string {
    if (!htmlContent || !htmlContent.includes('style')) {
        return htmlContent;
    }

    return htmlContent.replace(STYLE_ATTRIBUTE_REGEX, (match, prefix: string, quote: string, declarations: string) => {
        const rewritten = rewriteColorDeclarations(declarations);
        return rewritten === declarations ? match : `${prefix}${quote}${rewritten}${quote}`;
    });
}

function rewriteColorDeclarations(declarations: string): string {
    const parts = declarations.split(';');
    const kept: string[] = [];
    let changed = false;

    parts.forEach(part => {
        const separatorIndex = part.indexOf(':');
        const property = separatorIndex === -1 ? '' : part.slice(0, separatorIndex).trim().toLowerCase();
        if (!COLOR_STYLE_PROPERTIES.has(property)) {
            kept.push(part);
            return;
        }

        changed = true;
        const rawValue = part.slice(separatorIndex + 1).replace(/!important/gi, '').trim();
        const resolved = resolveCssColorForPdf(rawValue, property === 'background-color');
        if (resolved) {
            kept.push(`${property}:${resolved}`);
        }
    });

    return changed ? kept.join(';') : declarations;
}

/**
 * Resolves any CSS colour the browser accepts into "#rrggbb" (blended over white), or null when the
 * colour must be dropped (invalid, relative to the parent, or a fully transparent background).
 */
export function resolveCssColorForPdf(value: string, isBackground: boolean = false): string | null {
    const trimmed = (value || '').trim();
    if (!trimmed) {
        return null;
    }

    const cacheKey = `${isBackground ? 'bg:' : 'fg:'}${trimmed}`;
    if (resolvedCssColorCache.has(cacheKey)) {
        return resolvedCssColorCache.get(cacheKey)!;
    }

    const rgba = toRgbaComponents(trimmed);
    let resolved: string | null = null;
    if (rgba) {
        const [r, g, b, a] = rgba;
        if (!(isBackground && a === 0)) {
            const blend = (channel: number) => Math.round(channel * a + 255 * (1 - a));
            resolved = '#' + [blend(r), blend(g), blend(b)].map(c => c.toString(16).padStart(2, '0')).join('');
        }
    }

    resolvedCssColorCache.set(cacheKey, resolved);
    return resolved;
}

function toRgbaComponents(value: string): [number, number, number, number] | null {
    const lowered = value.toLowerCase();
    if (RELATIVE_COLOR_KEYWORDS.has(lowered) || lowered.includes('var(') || typeof document === 'undefined' || !document.body) {
        return null;
    }

    const probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;pointer-events:none;';
    document.body.appendChild(probe);
    try {
        probe.style.color = value;
        if (!probe.style.color) {
            return null; // rejected by the CSS parser
        }

        const computed = getComputedStyle(probe).color;
        return parseLegacyRgb(computed) || rasterizeColor(computed);
    } finally {
        probe.remove();
    }
}

function parseLegacyRgb(value: string): [number, number, number, number] | null {
    const match = LEGACY_RGB_REGEX.exec(value || '');
    if (!match) {
        return null;
    }

    const alpha = match[4] === undefined ? 1 : Number.parseFloat(match[4]);
    return [Number.parseFloat(match[1]), Number.parseFloat(match[2]), Number.parseFloat(match[3]), Number.isNaN(alpha) ? 1 : alpha];
}

// Modern colour syntaxes (oklch(), lab(), color(srgb ...)) are kept verbatim by getComputedStyle:
// paint them on a 1x1 canvas and read the resulting sRGB pixel.
function rasterizeColor(value: string): [number, number, number, number] | null {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    const context = canvas.getContext('2d');
    if (!context) {
        return null;
    }

    context.fillStyle = '#010203';
    context.fillStyle = value;
    if (context.fillStyle === '#010203') {
        return null; // not understood by the canvas colour parser either
    }

    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const [r, g, b, a] = context.getImageData(0, 0, 1, 1).data;
    return [r, g, b, a / 255];
}


const officeFooterGroups: { [key: string]: string[] } = {
    germany1: ['DGE', 'EG1', 'OCT'],
    france1: ['DFR', 'EF1', 'OCTF'],
    france2: ['SO1'],
    italy: ['DIT', 'EI1', 'OCTI'],
    usa: ['DUS', 'EU1']
};

const officeFooters: { [key: string]: string } = {
    germany1: 'DMV Deutschland GmbH · Bahnstraße 61, 42859 Remscheid, Germany · Sales: Wiesentraße 36, 45473 Mülheim an der Ruhr, Germany · Phone: +49 208 458-2611 · Telefax: +49 208 458-2641 · Email: salesgermany@dmvtubes.com · Internet: www.dmvtubes.com · Managing Directors: Mariano Pizzorno, Christophe Le Rigoleur, Emilio Giacomazzi· Corporate seat: Remscheid · Commercial Register: local court Wuppertal · Commercial Register entry: HRB 11874 · Banking connection: Deutsche Bank AG, BLZ 340 700 93, account: 611 21 22 · IBAN: DE94 3407 0093 0611 2122 00 · VAT ID no.: DE811571780',
    germany2: 'DMV GmbH • Wiesenstraße 36 • 45473 Mülheim an der Ruhr, Germany • Telefon: +49 208 458-01, Fax: +49 208 458-2640 • E-Mail: info@dmvtubes.com • Sitz der Gesellschaft: Mülheim an der Ruhr • Registergericht Amtsgericht, Duisburg, Registernummer: HRB 18154, USt-IdNr.: DE246294649 Geschäftsführung: Mariano Pizzorno, Christophe Le Rigoleur, Emilio Giacomazzi, Jörn Winkels • Bankverbindung: Deutsche Bank AG, BLZ 300 700 10, Konto: 3 300 399, IBAN DE67 3007 0010 0330 0399 00, Swift-BIC DEUTDEDDXXX • www.dmvtubes.com',
    france1: 'DMV France SAS • BP 10 Route de Semur • 21501 Montbard (cedex), France • Tél : +33 3 80 89 52 00 • E-Mail : france@dmvtubes.com • SAS au capital de 15 127 260 €, Siret n° 410 351 118 00022 • RCS Dijon 410 351 118, FR 79 410351118, NAF 2420Z • www.dmvtubes.com',
    france2: 'DMV SOTEP SAS • 67 Chemin des Midors • 36100 CHOUDAY, France • Tél : + 33 2 54 21 25 39 • SAS au capital de 6 250 000 €, Siret n° 530 545 755 00023 RCS Châteauroux 530 545 755, FR 70 530545755, NAF 2420Z • Courriel : sotep@dmvtubes.com • www.dmvtubes.com',
    italy: "DMV Italia S.r.l. • Via Pio’, 30 • 24062 Costa Volpino (BG), Italia • Tel.: +39 035 975 611 • Fax: +39 035 975 803 • E-Mail: italy@dmvtubes.com Internet: www.dmvtubes.com • S.r.l con un unico socio • Direzione e coordinamento: DMV GmbH, Capitale Sociale: € 1.200.000 iv • P.IVA: IT02276170160 Cod.Fisc.e Reg.Imprese: Bergamo 02276170160 • R.E.A.: BERGAMO 276608 • www.dmvtubes.com",
    usa: "DMV USA, Inc • 12050 West Little York, Houston, Texas 77041, USA • Tel: +1 713 466-7278, Fax: +1 713 466 0092 • E-Mail: usa@dmvtubes.com • FED ID 76-0458731 Managing Director: Eduardo Gomes • Deutsche Bank AG, Acct 00370941, ABA 021001033, BIC BKTRUS33XXX • www.dmvtubes.com"
};

function getOfficeFooter(officeCode: string): string {
    for (const [footerKey, officeCodes] of Object.entries(officeFooterGroups)) {
        if (officeCodes.includes(officeCode)) {
            return officeFooters[footerKey];
        }
    }
    return '';
}
